import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import { Button, Input, Modal } from "@template/ui";
import { useState } from "react";
import { useFinance } from "../FinanceContext";
import { MONTHS } from "../data/seedData";

/** Confirms + reason-captures an edit to an already-frozen (locked) period — creates a versioned revision. */
export function FrozenEditModal() {
  const { frozenEdit, setFrozenEdit, toDisp, fmt, applyFrozenEdit, locks, cur } = useFinance();
  const [val, setVal] = useState(() =>
    frozenEdit ? toDisp(frozenEdit.it[frozenEdit.field][frozenEdit.m] ?? 0) : 0,
  );
  const [reason, setReason] = useState("");

  if (!frozenEdit) return null;
  const { it, field, m } = frozenEdit;
  const lock = locks[m];

  function confirm() {
    if (!reason.trim() || !frozenEdit) return;
    applyFrozenEdit(frozenEdit, val, reason.trim());
    setReason("");
  }

  return (
    <Modal
      open
      onClose={() => setFrozenEdit(null)}
      title="Modify Frozen Period"
      maxWidth="sm"
      actions={
        <>
          <Button onClick={() => setFrozenEdit(null)}>No — Cancel</Button>
          <Button variant="contained" disabled={!reason.trim()} onClick={confirm}>
            Yes — Create New Version
          </Button>
        </>
      }
    >
      <Stack spacing={2}>
        <Alert severity="warning">
          You are modifying an <strong>approved and frozen</strong> financial period ({MONTHS[m]} ·{" "}
          {lock ? lock.level : "Locked"}). This creates a new version and requires dual approval.
        </Alert>
        <Input label="Cost Head" value={it.name} slotProps={{ input: { readOnly: true } }} />
        <Input
          label={`Current ${field === "planned" ? "Budget" : "Actual"} (${MONTHS[m]})`}
          value={fmt(it[field][m] ?? 0)}
          slotProps={{ input: { readOnly: true } }}
        />
        <Input
          label={`New Value (${cur})`}
          type="number"
          value={val}
          onChange={(e) => setVal(Number(e.target.value))}
        />
        <Input
          label="Reason for change (mandatory)"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          multiline
          minRows={2}
          placeholder="e.g. Revenue adjustment — reallocation approved by CFO"
        />
      </Stack>
    </Modal>
  );
}
